import React from "react";
import TabWrapper from "./TabWrapper";
import { SettingsPageTab, TabProps } from "./types";

const SecurityTab = (props: TabProps) => {
  return <TabWrapper id={SettingsPageTab.SECURITY}>В разработке.</TabWrapper>;
};

export default SecurityTab;
